import {
  GET_SUBSCRIPTION_PLAN,
  PAUSE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_PLAN,
  SUBSCRIPTION_FEEDBACK_REQUEST,
} from "../../utils/constants";

// ------------------------------------
// Actions
// ------------------------------------

export function getSubscriptionPlan(value) {
  return {
    type: GET_SUBSCRIPTION_PLAN,
    payload: value,
  };
}

export const upgradePlan = (data) => {
  return {
    type: UPDATE_SUBSCRIPTION_PLAN,
    payload: data,
  };
};

export const pauseSubscription = (data) => {
  return {
    type: PAUSE_SUBSCRIPTION,
    payload: data,
  };
};

export const submitSubscriptionFeedback = (data) => {
  return {
    type: SUBSCRIPTION_FEEDBACK_REQUEST,
    payload: data,
  };
};

export const actions = {
  getSubscriptionPlan,
  upgradePlan,
  pauseSubscription,
  submitSubscriptionFeedback,
};
